import React from 'react';
import { Provider } from 'react-redux';
import App from './containers/App';
import StoreHandler from './reducers/app';

const TestDriveApp = () => {
  const store = StoreHandler();
  // initFindUsApp(store);

  return (
    <Provider store={store}>
      <App store={store} />
    </Provider>
  );
};

export default TestDriveApp;